export default "__VITE_ASSET__BXDhnBcb__"